import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { PerfVsIndexCapsuleConfigState } from 'widgets/perfVsIndexCapsule/store/config/PerfVsIndexCapsuleConfigState';
import { useFillsGraphStreamedData } from 'widgets/fillsGraph/store/streamedData/hooks';

export function usePerfVsIndexCapsuleMessagesInMyPortfolioCapsules(
    symbol: string
) {
    const {
        config: { indexFallback },
    } = useMyPortfolioCapsuleConfigSlice<PerfVsIndexCapsuleConfigState>();

    const { streamedData } = useFillsGraphStreamedData(symbol, indexFallback);

    const streamMessages = streamedData?.messages ?? [];

    return [...streamMessages];
}
